import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretCircleDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.4196 11.1375C20.4196 6.01151 16.2641 1.85607 11.1381 1.85607C6.01213 1.85607 1.85669 6.01151 1.85669 11.1375C1.85669 16.2635 6.01213 20.4189 11.1381 20.4189C16.2641 20.4189 20.4196 16.2635 20.4196 11.1375Z",
		fill: "#42296E"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.6571 9.2979L11.1382 13.42995L14.6193 9.2979",
		stroke: "white",
		strokeWidth: 1.6184,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCaretCircleDown;
